import axios from "../axios"
const context = process.env.VUE_APP_BOOKING_BASE_SERVER_PATH;

// 圖形-取消預約申請驗證碼
const cancelCaptcha = async () => {
    return axios.get(`${context}/public/captcha/graph/cancel-app`, {
        responseType: 'blob'
    }).then(({
        data
    }) => {
        return data
    })
}
// 圖形-完結預約驗證碼
const finishCaptcha = async () => {
    return axios.get(`${context}/public/captcha/graph/finish-app`, {
        responseType: 'blob'
    }).then(({
        data
    }) => {
        return data
    })
}
// 圖形-登錄驗證碼
const loginCaptcha = async () => {
    return axios.get(`${context}/public/captcha/graph/login-web`, {
        responseType: 'blob'
    }).then(({
        data
    }) => {
        return data
    })
}
// 圖形-查詢預約申請驗證碼
const queryCaptcha = async () => {
    return axios.get(`${context}/public/captcha/graph/query-app`, {
        responseType: 'blob'
    }).then(({
        data
    }) => {
        return data
    })
}
// 圖形-提交預約申請驗證碼
const submitCaptcha = async () => {
    return axios.get(`${context}/public/captcha/graph/submit-app`, {
        responseType: 'blob'
    }).then(({
        data
    }) => {
        return data
    })
}
// 圖形-修改預約申請驗證碼
const updateCaptcha = async () => {
    return axios.get(`${context}/public/captcha/graph/update-app`, {
        responseType: 'blob'
    }).then(({
        data
    }) => {
        return data
    })
}
// 手機-查詢預約申請驗證碼
const mobileQueryCaptcha = async (businessCode, mobile, language) => {
    return axios.get(`${context}/public/captcha/mobile/query-app`, {
        params: {
            businessCode, mobile, language
        }
    }).then(({
        data
    }) => {
        return data
    })
}
// 手機-提交預約申請驗證碼
const submitQueryCaptcha = async (businessCode, mobile, language) => {
    return axios.get(`${context}/public/captcha/mobile/submit-app`, {
        params: {
            businessCode, mobile, language
        }
    }).then(({
        data
    }) => {
        return data
    })
}


export default {
    cancelCaptcha,
    finishCaptcha,
    loginCaptcha,
    queryCaptcha,
    submitCaptcha,
    updateCaptcha,
    mobileQueryCaptcha,
    submitQueryCaptcha,
}